export enum AuthActionType {
  setTokens = 'set-tokens',
  resetTokens = 'reset-tokens',
}

export type SetTokensPayload = {
  accessToken: string;
};

export type SetTokensAction = {
  type: AuthActionType.setTokens;
  payload: SetTokensPayload;
};

export type ResetTokensAction = {
  type: AuthActionType.resetTokens;
};

export type AuthAction = SetTokensAction | ResetTokensAction;
